<div class="accordion accordion-flush accordion-white" [id]="'accordion-' + id">
  <div class="accordion-item">
    <h2 class="accordion-header" [id]="'flush-heading-' + id">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        [attr.data-bs-target]="'#flush-collapse-' + id"
        aria-expanded="false"
        [attr.aria-controls]="'flush-collapse-' + id"
      >
        <span [innerHTML]="title"></span>
      </button>
    </h2>
    <div
      [id]="'flush-collapse-' + id"
      class="accordion-collapse collapse"
      [attr.aria-labelledby]="'flush-heading-' + id"
    >
      <div class="accordion-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
